module.exports = __webpack_public_path__ + "img/farewell-of-snezhnaya.f64130ba.webp";